export default __webpack_public_path__ + "static/media/ic_ahu_floor.9cd09300.svg";